import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';

import { DatapointsMultiQuery } from '@cognite/sdk-alpha';

import { CHART_POINTS_PER_SERIES } from '../constants';
import { fetchRawOrAggregatedDatapoints } from '../services/fetch-raw-or-aggregated-datapoints-alpha';
import { calculateGranularity } from '../utils';
import { useAlphaSDK } from '../utils/alphaSDKProvider';

export function useCoreTimeSeriesDatapoints(
  nodeReference: { space: string; externalId: string },
  debouncedRange: { dateFrom: string; dateTo: string },
  aggregationDataPointLimit: number
) {
  const sdk = useAlphaSDK();

  const query: DatapointsMultiQuery = {
    items: [
      {
        // TODO(CHART-2242): Followup to remove this ts-expect-error
        //@ts-expect-error SDK hasn't been updated yet..
        instanceId: {
          space: nodeReference.space,
          externalId: nodeReference.externalId,
        },
        includeStatus: true,
        ignoreBadDataPoints: false,
        treatUncertainAsBad: false,
      },
    ],
    start: dayjs(debouncedRange.dateFrom).toDate(),
    end: dayjs(debouncedRange.dateTo).toDate(),
    granularity: calculateGranularity(
      [
        dayjs(debouncedRange.dateFrom).valueOf(),
        dayjs(debouncedRange.dateTo).valueOf(),
      ],
      CHART_POINTS_PER_SERIES
    ),
    aggregates: ['average', 'min', 'max', 'count', 'sum'],
    limit: CHART_POINTS_PER_SERIES,
  };

  return useQuery(
    [
      'chart-data',
      'coreTimeseries-datapoints',
      nodeReference.externalId,
      query,
    ],
    () => fetchRawOrAggregatedDatapoints(sdk, query, aggregationDataPointLimit),
    {
      enabled: !!nodeReference.externalId,
    }
  );
}
